import { ConsentCookieBanner } from './app'

ConsentCookieBanner({ showClose: true, showDeclineAll: true })
ConsentCookieBanner.onFontsLoaded()
